import React from 'react';
import { SearchBarProvider } from 'Components/AdvisorApp/Header/ClientSearchBar/BetaSearchBar/SearchBarContext';
import Root from './Root';

// Pull off className here because I don't want that to push down in this case
const BetaSearchBar = ({ className, ...rest }) => {
  return (
    <SearchBarProvider>
      <Root {...rest} />
    </SearchBarProvider>
  );
};

export default BetaSearchBar;
